import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchPatientTodayAppointments = createAsyncThunk(
  "report/fetchPatientTodayAppointments",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.PATIENT_TODAY_APPOINTMENT,
        {
          params: credentials,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const fetchPatientAppointmentHistory = createAsyncThunk(
  "report/fetchPatientAppointmentHistory",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.PATIENT_APPOINTMENT_HISTORY,
        {
          params: credentials,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  today: {
    loading: false,
    error: null,
    data: null,
  },
  history: {
    today: { data: [], loading: false },
    past: { data: [], loading: false },
    future: { data: [], loading: false },
  },
};

// ------------------ SLICE ------------------
const AppointmentsSlice = createSlice({
  name: "Appointments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatientTodayAppointments.pending, (state) => {
        state.today.loading = true;
        state.today.error = null;
      })
      .addCase(fetchPatientTodayAppointments.fulfilled, (state, action) => {
        state.today.loading = false;
        state.today.data = action.payload;
      })
      .addCase(fetchPatientTodayAppointments.rejected, (state, action) => {
        state.today.loading = false;
        state.today.error = action.payload;
      });
    builder
      .addCase(fetchPatientAppointmentHistory.pending, (state, action) => {
        const { filters } = action.meta.arg;
        state.history[filters].loading = true;
      })
      .addCase(fetchPatientAppointmentHistory.fulfilled, (state, action) => {
        const { filters } = action.meta.arg;
        state.history[filters].loading = false;
        state.history[filters].data = action.payload.data;
      })
      .addCase(fetchPatientAppointmentHistory.rejected, (state, action) => {
        const { filters } = action.meta.arg;
        state.history[filters].loading = false;
        state.history[filters].data = [];
      });
  },
});

export default AppointmentsSlice.reducer;
